import { useEffect, useState } from "react";
import { connect } from "react-redux";

const UpiIntentProcessing = ({ statusUrl }) => {
    const [intentOpened, setIntentOpened] = useState(false);
    const [blurTimestamp, setBlurTimestamp] = useState(null);
    const [showFallback, setShowFallback] = useState(false);

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    useEffect(() => {
        const handleBlur = () => {
            setIntentOpened(true);
            setBlurTimestamp(Date.now());
        };

        window.addEventListener("blur", handleBlur);
        return () => window.removeEventListener("blur", handleBlur);
    }, []);

    useEffect(() => {
        const handleFocus = () => {
            if (!intentOpened) return;

            const elapsed = Date.now() - (blurTimestamp || 0);
            if (!isIOS && elapsed > 1800) {
                window.location.href = statusUrl;
            }

            if (elapsed > 1500) {
                setShowFallback(true);
            }
        };

        window.addEventListener("focus", handleFocus);
        return () => window.removeEventListener("focus", handleFocus);
    }, [intentOpened, blurTimestamp, statusUrl]);

    useEffect(() => {
        const visHandler = () => {
            if (!intentOpened) return;

            const elapsed = Date.now() - (blurTimestamp || 0);

            if (!isIOS && document.visibilityState === "visible" && elapsed > 1800) {
                window.location.href = statusUrl;
            }

            if (elapsed > 1500) {
                setShowFallback(true);
            }
        };

        document.addEventListener("visibilitychange", visHandler);
        return () => document.removeEventListener("visibilitychange", visHandler);
    }, [intentOpened, blurTimestamp, statusUrl]);

    return (
        <div className="fixed top-0 left-0 w-screen h-screen bg-[#1d2630] z-[10000] flex flex-col justify-center items-center text-white">
            <div className="spinner-box">
                <div className="configure-border-1"><div className="configure-core"></div></div>
                <div className="configure-border-2"><div className="configure-core"></div></div>
            </div>

            <div className="flex flex-col items-center text-center pt-12 leading-tight">
                <h3 className="font-normal text-lg">Please Wait...</h3>
                <p className="text-[#C0AF90] text-sm mt-8">Do not close the browser or press back button</p>

                {showFallback && (
                    <div className="mt-5 px-4 py-3 rounded-lg bg-[#ffffff15] backdrop-blur-sm border border-[#ffffff25] shadow-md animate-fade-in text-center">
                        <p className="text-xs text-gray-300 leading-relaxed">
                            If this screen does not redirect automatically after payment,
                        </p>
                        <button
                            onClick={() => window.location.href = statusUrl}
                            className="mt-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded-md transition-all"
                        >
                            Tap here to continue
                        </button>
                    </div>
                )}

            </div>

            <button
                onClick={() => window.location.href = statusUrl}
                className="text-white absolute top-8 left-8"
            >
                <svg width="1rem" height="1rem" viewBox="0 0 1024 1024">
                    <path fill="#ffffff" d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z" />
                    <path fill="#ffffff"
                        d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"
                    />
                </svg>
            </button>
        </div>
    );
};

export default connect((state) => ({ device: state.device }))(UpiIntentProcessing);